"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = [{
  name: 'elements',
  element: '.image-spot-elements',
  type: 'imageSpotList'
}];
exports["default"] = _default;